// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/estoque/hooks/useRelatoriosEstoque.ts
// ════════════════════════════════════════════════════════════════════════════

import { useQuery } from '@tanstack/react-query';
import { relatoriosEstoqueService } from '../services/relatoriosEstoqueService';

interface UseAnaliticoParams {
  produtoId?: number;
  localId?: number;
  tipoId?: number;
  dtInicio?: string;
  dtFim?: string;
  pagina?: number;
  tamanhoPagina?: number;
}

export const useEstoqueAnalitico = (params: UseAnaliticoParams = {}) =>
  useQuery({
    queryKey: ['estoque-analitico', params],
    queryFn: () => relatoriosEstoqueService.getAnalitico(params),
  });

interface UseGiroParams {
  dtInicio?: string;
  dtFim?: string;
  localId?: number;
}

export const useEstoqueGiro = (params: UseGiroParams = {}) =>
  useQuery({
    queryKey: ['estoque-giro', params],
    queryFn: () => relatoriosEstoqueService.getGiro(params),
  });
